import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RsLoaderComponent } from '@rs-shared-lib/components/rs-loader/components/rs-loader.component';
import { RsTopBarMenuComponent } from '@rs-shared-lib/components/topbar/rs-top-bar-menu.component';
import { RsFooterComponent } from '@rs-shared-lib/components/footer/rs-footer.component';
import { MenuItem } from '@rs-shared-lib/models/top-bar-menu-items';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '@app/shared/services/user.service';
import { Title } from '@angular/platform-browser';
import { BRAND_NAMES } from '@rs-shared-lib/constants/brand-names';

@Component({
  imports: [RsTopBarMenuComponent, RsFooterComponent, RouterOutlet, RsLoaderComponent, TranslateModule],
  selector: 'app-mobi-clear-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public readonly menuItems = signal<MenuItem[]>([]);
  private readonly userService = inject(UserService);
  private readonly titleService = inject(Title);

  constructor() {
    this.titleService.setTitle(BRAND_NAMES['MOBICLEAR']);
    this.userService.fetchUser$
      .subscribe(() => this.setTopBarMenu());
  }

  public onLogout(): void {
    localStorage.clear();
  }

  private setTopBarMenu(): void {
    this.menuItems.set([
      ...this.getFleetOwnerMenu(),
      ...this.getPartnerMenu(),
    ]);
  }

  private getFleetOwnerMenu(): MenuItem[] {
    return [
      {
        id: 'deregistrations',
        label: 'DEREGISTRATIONS',
        url: 'deregistrations',
        display: this.userService.isDeregistrationsUser()
      },
      {
        id: 'verified-transport',
        label: 'VERIFIED_TRANSPORT',
        url: 'verified-transport',
        display: this.userService.isVerifiedTransportUser()
      },
      {
        id: 'data-import',
        label: 'DATA_IMPORT',
        url: 'data-import',
        display: this.userService.isDataImportUser()
      },
      {
        id: 'administration',
        label: 'ADMINISTRATION',
        url: 'administration',
        display: this.userService.isAdministrationUser()
      }
    ]
  }

  private getPartnerMenu(): MenuItem[] {
    return [
      {
        id: 'home',
        label: 'HOME',
        url: 'home',
        display: this.userService.isPickUpUser()
      },
      {
        id: 'scan-license-plates',
        label: 'SCAN_LICENSE_PLATES',
        url: 'scan-license-plates',
        display: this.userService.isPickUpUser()
      }
    ];
  }
}
